import React from "react";
import Navbar3 from "../Components/Navbar3";
// import Carousel from "../Components/Carousel";
import ExperienceCarousel from "../Components/ExperieceCarousel";
import TextDivider from "../Components/TextDivider";
import Footer from "../Components/Footer";
import UpcomingEvents from "../Components/UpcomingEvents";
import UltimateEvent from "../Components/UltimateEvent";
import MusicFeature from "../Components/MusicFeature";
import Spacer from "../Components/Spacer";
import ComedyFeature from "../Components/ComedyFeature";
import CombatFeature from "../Components/CombatFeature";
import SportsFeature from "../Components/SportsFeature";
import SeasonalFeature from "../Components/SeasonalFeature";
import HomeHeroCarousel from "../Components/HomeHeroCarousel";

function Home() {
  return (
    <>
      <Navbar3 />
      <HomeHeroCarousel />
      <ExperienceCarousel />
      <TextDivider />
      <UpcomingEvents />
      <TextDivider />
      <UltimateEvent />
      <Spacer />
      <MusicFeature />
      <Spacer />
      <ComedyFeature />
      <Spacer />
      <CombatFeature />
      <Spacer />
      <SportsFeature />
      <Spacer />
      <SeasonalFeature />
      <Spacer />
      <TextDivider />
      <Footer />
    </>
  ); 
}
export default Home;